import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {IGroupedDevice} from '../../../shared';
import {Device} from '../../../afb-api/models/device';

@Component({
  selector: 'awair-group-detail',
  templateUrl: './group-detail.component.html',
  styleUrls: ['./group-detail.component.scss']
})

export class GroupDetailComponent implements OnInit {

  // Listening key press for the shortcut feature
  @HostListener('window:keydown', ['$event'])
  onKeyDown(event) {
    this.pressedKey = event.key;
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event) {
    this.pressedKey = null;
  }

  // Send this group id
  @Output() addDevice: EventEmitter<IGroupedDevice> = new EventEmitter();
  @Output() assignToGroup: EventEmitter<{ groupId: number, deviceList: Device[] }> = new EventEmitter();
  @Output() removeFromGroup: EventEmitter<{ group: IGroupedDevice, deviceList: Device[] }> = new EventEmitter();
  @Output() deleteGroup: EventEmitter<any> = new EventEmitter();
  @Output() manageMember: EventEmitter<IGroupedDevice> = new EventEmitter();

  get selectedGroup() {
    return this._selectedGroup;
  }
  @Input()
  set selectedGroup(value: IGroupedDevice) {
    if (value != null) {
      this._selectedGroup = Object.assign({}, value);

      if (this.selectedGroup.name == null) {
        this._selectedGroup.name = 'Unassigned';
      }
      // Create deviceWithCheckList
      // Always initialize when new group enters
      this.isAllChecked = false;
      this.deviceWithCheckList = [];
      this.selectedDeviceList = [];
      for (let i = 0; i < this.selectedGroup.deviceList.length; i++) {
        this.deviceWithCheckList.push(Object.assign({}, this._selectedGroup.deviceList[i], {checked: false}));
        // Needs to show device list in alphabetical order
        // Not using objArraySort pipe since it breaks multi select logic
        this.deviceWithCheckList.sort((a: IDeviceWithCheck, b: IDeviceWithCheck) => {
          if (a.deviceName < b.deviceName) {
            return -1;
          } else if (a.deviceName > b.deviceName) {
            return 1;
          } else {
            return 0;
          }
        });
      }
    }
  }
  private _selectedGroup: IGroupedDevice;

  get groupedDeviceList() {
    return this._groupedDeviceList;
  }
  @Input()
  set groupedDeviceList(value: IGroupedDevice[]) {
    if (value != null) {
      this._groupedDeviceList = [...value];
    }
  }
  private _groupedDeviceList: IGroupedDevice[];

  selectedDeviceList: Device[] = [];
  deviceWithCheckList: IDeviceWithCheck[] = [];
  isAllChecked: boolean = false;
  isActionDropdown: boolean = false;
  otherGroupedDeviceList: IGroupedDevice[] = [];
  private pressedKey: string;
  private lastSelectedDeviceIndex: number = 0;

  constructor() {
  }

  ngOnInit() {
  }

  onDropdownEvent(event: MouseEvent, dropdownContainer: HTMLElement, isMove: boolean): void {
    if (isMove) {
      // Get group list without itself when move to is selected
      this.otherGroupedDeviceList = this.getOtherGroupedDeviceList(this.groupedDeviceList, this.selectedGroup);
    }
    const dropdownEl: HTMLElement = dropdownContainer.querySelector('ul');

    if (!(dropdownContainer.contains(event.target as HTMLElement)) && dropdownEl) {
      // If selected element is not dropdown element,
      dropdownEl.style.display = 'none';

    } else if (dropdownEl) {
      // If selected element is dropdown element, make it toggle
      // On init, element's display is set to ''
      dropdownEl.style.display = dropdownEl.style.display === 'none' || dropdownEl.style.display === '' ? 'block' : 'none';
    }
  }

  selectDevice(selectedDevice: IDeviceWithCheck): void {
    const deviceIndex = this.getDeviceIndex(this.deviceWithCheckList, selectedDevice);

    if (this.pressedKey === 'Shift') {
      const orderedIndexList = [deviceIndex, this.lastSelectedDeviceIndex].sort((a, b) => a - b);

      if (selectedDevice.checked) {
        for (let i = orderedIndexList[0]; i <= orderedIndexList[1]; i++) {
          if (this.deviceWithCheckList[i].checked) {
            this.uncheckDevice(this.deviceWithCheckList[i], this.selectedDeviceList);
          }
        }
      } else {
        for (let i = orderedIndexList[0]; i <= orderedIndexList[1]; i++) {
          if (!(this.deviceWithCheckList[i].checked)) {
            this.checkDevice(this.deviceWithCheckList[i], this.selectedDeviceList);
          }
        }
      }

    } else {
      selectedDevice.checked ? this.uncheckDevice(selectedDevice, this.selectedDeviceList) :
        this.checkDevice(selectedDevice, this.selectedDeviceList);
    }

    this.lastSelectedDeviceIndex = deviceIndex;
    // To automatically set allCheck checkbox
    this.isAllChecked = this.selectedDeviceList.length === this.selectedGroup.deviceList.length ? true : false;
  }

  selectAllCheck(isAllChecked: boolean): void {
    this.isAllChecked = !isAllChecked;
    this.selectedDeviceList = [];

    if (this.isAllChecked) {
      this.deviceWithCheckList.forEach((deviceWithCheck: IDeviceWithCheck) => {
        this.checkDevice(deviceWithCheck, this.selectedDeviceList);
      });

    } else {
      this.deviceWithCheckList.forEach((deviceWithCheck: IDeviceWithCheck) => {
        deviceWithCheck.checked = false;
      });
    }
  }

  onAddDevice(): void {
    this.addDevice.emit(this.selectedGroup);
  }

  onDeleteGroup(): void {
    this.deleteGroup.emit(this.selectedGroup);
  }

  onAssignToGroup(groupId: number): void {
    this.assignToGroup.emit({'groupId': groupId, 'deviceList': this.selectedDeviceList});
  }

  onRemoveFromGroup(): void {
    this.removeFromGroup.emit({'group': this.selectedGroup, 'deviceList': this.selectedDeviceList});
  }

  onManageMember(): void {
    this.manageMember.emit(this.selectedGroup);
  }

  getOtherGroupedDeviceList(groupedDeviceList: IGroupedDevice[], selectedGroup: IGroupedDevice): IGroupedDevice[] {
    // const copyGroupedDeviceList = [...groupedDeviceList];
    // // Remove this group
    // const index = copyGroupedDeviceList.map((groupedDevice: IGroupedDevice) => groupedDevice.id).indexOf(selectedGroup.id);
    // if (index !== -1) {
    //   copyGroupedDeviceList.splice(index, 1);
    // }
    // Remove unassigned
    // const unassignedIndex = copyGroupedDeviceList.map((groupedDevice: IGroupedDevice) => groupedDevice.id).indexOf(-1);
    // if (unassignedIndex !== -1) {
    //   copyGroupedDeviceList.splice(unassignedIndex, 1);
    // }
    return groupedDeviceList.filter((groupedDevice: IGroupedDevice) =>
      groupedDevice.id != null && groupedDevice.id !== selectedGroup.id)

    // return copyGroupedDeviceList;
  }

  // The following two methods mutate their parameters
  private checkDevice(selectedDeviceWithCheck: IDeviceWithCheck, selectedDeviceList: Device[]): void {
    selectedDeviceWithCheck.checked = true;
    const copySelectedDevice: IDeviceWithCheck = Object.assign({}, selectedDeviceWithCheck);
    delete copySelectedDevice.checked;
    selectedDeviceList.push(copySelectedDevice);
  }

  private uncheckDevice(selectedDeviceWithCheck: IDeviceWithCheck, selectedDeviceList: Device[]): void {
    selectedDeviceWithCheck.checked = false;
    selectedDeviceList.splice(this.getDeviceIndex(selectedDeviceList, selectedDeviceWithCheck), 1);
  }

  private getDeviceIndex(deviceList: Device[], selectedDevice: Device): number {
    return deviceList.findIndex((device: Device) => {
      return device.deviceId === selectedDevice.deviceId && device.deviceType === selectedDevice.deviceType;
    });
  }
}

export interface IDeviceWithCheck extends Device {
  checked: boolean;
}
